import { render, staticRenderFns } from "./WorkflowFormSubmissionCommentField.vue?vue&type=template&id=6f58e3fe&"
import script from "./WorkflowFormSubmissionCommentField.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionCommentField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports